import React ,{useEffect,useState}from 'react';
import { officeWwideLocPage, officeWwideLocPagear } from '../../service/apiService';
import { config } from '../../config/rest';
import { Lang } from '../../component/Language/Lang';
import { useSelector,useDispatch } from "react-redux";
export const WorldWideWeb = () => {
  const [wwlData,setwwlData]=useState([]);
  const langData=useSelector(state=>state.cart);
  useEffect(() => {
    window.scrollTo({
      top: 100,
      behavior: 'smooth',
    })
    getwwlData(); 
  },[langData]);
  
  const getwwlData=async()=>{
  //  console.log('datra isdfdjf');
    const wwlData=langData.lang==='ar'?await officeWwideLocPagear():await officeWwideLocPage();
    // console.log('datra is',wwlData.data.data);
    setwwlData(wwlData.data.data); 
  }
  
  return (
    <section>
    <div className="container">
                <div className="section-heading text-center mb-2-9 mb-lg-6 wow fadeIn" data-wow-delay="100ms">
                    <span>{Lang[langData.lang].wwloc}</span>
                    <h2 className="h1 mb-0">{Lang[langData.lang].wwloc}</h2>
                </div>
                <div className="col-lg-12 wow fadeIn table-responsive" data-wow-delay="400ms">
                {wwlData && wwlData.map(function (data, index) {
            return (
                
                 <div className="row" key={index}>
                 
                 <div className="col-2 col-md-2"></div>
                                    <div className="col-4 col-md-4">
                                        <div className="image-hover card-style1">
                                          {data.attributes.Image.data  && 
                                            <img src={config.IMG_URL+data.attributes.Image.data.attributes.url} alt="..." /> 
                                          }
                                            </div>
                                    </div>
                                    <div className="col-4 col-md-4">
                                      <div className="card-body pb-1-9 px-1-9  ">
                                      <div dangerouslySetInnerHTML={{ __html:data.attributes.Address}} >
                                       
                                      </div>
                                      </div>
                                    
                                    </div>
          
                                   
                                </div>
                                  )})}
                            </div>
                
      </div>
</section>
  )
}
